// ---------------------------------------
// Locale.js
// Otvaracie okna s jedinecnymi id
// ---------------------------------------
var CollapseItem = {
    Init: function () {    

        $('.more').click(function(){
            var spanText = $(this).find('span').text();
            var infoParagraph = $(this).closest('.info').find('p');
            
            if(spanText === 'viac'){
                $(this).find('span').text('menej');
                $(this).find('i').removeClass('fa-arrow-down').addClass('fa-arrow-up');
                infoParagraph.slideDown(); // Animácia slide down
            }
            else{
                $(this).find('span').text('viac');
                $(this).find('i').removeClass('fa-arrow-up').addClass('fa-arrow-down');
                infoParagraph.slideUp(); // Animácia slide up
            }
        });
    }    
};
module.exports = CollapseItem;